import type { SvgIconProps } from '~/@mid_ui/icons/svgIcon'
import { SvgIcon } from '~/@mid_ui/icons/svgIcon'

export function NoInvestmentsSvg({
  width = 424,
  height = 314,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 425 316" {...props}>
      <path
        stroke="#DBDADA"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M55.077 132.01h-15.03M47.57 124.5v15.03M45.827 144.379h-9.71M40.977 139.529v9.71"></path>
      <path
        fill="#fff"
        d="M53.395 153.66h28.23v-6.95h-28.23v6.95zM53.395 166.5h28.23v-6.95h-28.23v6.95z"></path>
      <path
        fill="#E8E6E6"
        d="M302.137 114.12c0 1.82-1.48 3.3-3.3 3.3h-5.43c-3.98 0-7.16 3.35-6.89 7.37.25 3.67 3.46 6.43 7.14 6.43h46.9c3.8 0 6.9-3.09 6.9-6.91 0-1.9-.78-3.63-2.02-4.87a6.845 6.845 0 00-4.87-2.02h-22.37c-1.82 0-3.3-1.48-3.3-3.3 0-1.82 1.48-3.3 3.3-3.3h2.05c8.34 0 15.52-6.3 16.13-14.62.35-4.81-1.47-9.24-4.59-12.34a15.75 15.75 0 00-11.17-4.63h-112.7c-8.73 0-15.8 7.07-15.8 15.79 0 4.36 1.77 8.32 4.63 11.17 2.85 2.86 6.81 4.63 11.17 4.63h90.92c1.82 0 3.3 1.48 3.3 3.3zM177.23 186.27v100.9H27.91c-6.25 0-11.31-5.06-11.31-11.31 0-3.12 1.27-5.94 3.31-7.99 2.05-2.04 4.89-3.31 8-3.31h9.68c1.48 0 2.69-1.21 2.69-2.69a2.7 2.7 0 00-2.69-2.7H5.93c-3.28 0-5.93-2.65-5.93-5.92 0-3.28 2.65-5.93 5.93-5.93h64.61c4.37 0 7.91-3.54 7.91-7.91 0-2.19-.89-4.16-2.32-5.59a7.91 7.91 0 00-5.59-2.32H43.19c-12.49 0-22.62-10.13-22.62-22.62 0-6.24 2.54-11.9 6.63-15.99 4.09-4.1 9.74-6.63 15.99-6.63h134.05l-.01.01z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M380.898 186.09h-142.89a6.18 6.18 0 00-6.18 6.18v88.9a6.18 6.18 0 006.18 6.18h142.89a6.18 6.18 0 006.18-6.18v-88.9a6.18 6.18 0 00-6.18-6.18z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M376.172 186.09h-142.89a6.18 6.18 0 00-6.18 6.18v88.9a6.18 6.18 0 006.18 6.18h142.89a6.18 6.18 0 006.18-6.18v-88.9a6.18 6.18 0 00-6.18-6.18z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M382.352 205.43h-155.25v19.13h155.25v-19.13z"></path>
      <path
        fill="#fff"
        stroke="#3F6EEC"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M361.343 250.16h-18.99a2.47 2.47 0 00-2.47 2.47v13.71a2.47 2.47 0 002.47 2.47h18.99a2.47 2.47 0 002.47-2.47v-13.71a2.47 2.47 0 00-2.47-2.47z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M424.343 314.891H14.383"></path>
      <path
        fill="#DBDADA"
        d="M92.403 278.201c16.729 0 30.279-13.56 30.279-30.28s-13.56-30.28-30.28-30.28h-9.09v60.569h9.09v-.009z"></path>
      <mask
        id="mask0_5171_29427"
        style={{ maskType: 'luminance' }}
        width="40"
        height="62"
        x="83"
        y="217"
        maskUnits="userSpaceOnUse">
        <path
          fill="#fff"
          d="M92.403 278.201c16.729 0 30.279-13.56 30.279-30.28s-13.56-30.28-30.28-30.28h-9.09v60.569h9.09v-.009z"></path>
      </mask>
      <g
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        mask="url(#mask0_5171_29427)">
        <path d="M48.984 217.631h93.5M48.984 227.73h93.5M48.984 237.82h93.5M48.984 247.922h93.5M48.984 258.012h93.5M48.984 268.111h93.5M48.984 278.201h93.5"></path>
      </g>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M92.403 278.201c16.729 0 30.279-13.56 30.279-30.28s-13.56-30.28-30.28-30.28h-9.09v60.569h9.09v-.009z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M83.303 278.201c16.724 0 30.28-13.557 30.28-30.28 0-16.724-13.556-30.28-30.28-30.28-16.723 0-30.28 13.556-30.28 30.28 0 16.723 13.557 30.28 30.28 30.28z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M83.302 274.16c14.492 0 26.24-11.748 26.24-26.24 0-14.492-11.748-26.24-26.24-26.24-14.492 0-26.24 11.748-26.24 26.24 0 14.492 11.749 26.24 26.24 26.24z"></path>
      <path fill="#fff" d="M122.682 302.66h-66.33v12.23h66.33v-12.23z"></path>
      <mask
        id="mask1_5171_29427"
        style={{ maskType: 'luminance' }}
        width="67"
        height="13"
        x="56"
        y="302"
        maskUnits="userSpaceOnUse">
        <path fill="#fff" d="M122.682 302.66h-66.33v12.23h66.33v-12.23z"></path>
      </mask>
      <g
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        mask="url(#mask1_5171_29427)">
        <path d="M56.352 314.89v-17.13M67.398 314.89v-17.13M78.46 314.89v-17.13M89.523 314.89v-17.13M100.57 314.89v-17.13M111.633 314.89v-17.13M122.68 314.89v-17.13"></path>
      </g>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M122.682 302.66h-66.33v12.23h66.33v-12.23z"></path>
      <path fill="#fff" d="M115.65 290.43H49.32v12.23h66.33v-12.23z"></path>
      <mask
        id="mask2_5171_29427"
        style={{ maskType: 'luminance' }}
        width="67"
        height="13"
        x="49"
        y="290"
        maskUnits="userSpaceOnUse">
        <path fill="#fff" d="M115.65 290.43H49.32v12.23h66.33v-12.23z"></path>
      </mask>
      <g
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        mask="url(#mask2_5171_29427)">
        <path d="M49.32 302.659v-17.13M60.383 302.659v-17.13M71.43 302.659v-17.13M82.492 302.659v-17.13M93.54 302.659v-17.13M104.602 302.659v-17.13M115.664 302.659v-17.13"></path>
      </g>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M115.65 290.43H49.32v12.23h66.33v-12.23z"></path>
      <path fill="#fff" d="M122.682 278.199h-66.33v12.23h66.33v-12.23z"></path>
      <mask
        id="mask3_5171_29427"
        style={{ maskType: 'luminance' }}
        width="67"
        height="13"
        x="56"
        y="278"
        maskUnits="userSpaceOnUse">
        <path
          fill="#fff"
          d="M122.682 278.199h-66.33v12.23h66.33v-12.23z"></path>
      </mask>
      <g
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        mask="url(#mask3_5171_29427)">
        <path d="M56.352 290.429v-17.13M67.398 290.429v-17.13M78.46 290.429v-17.13M89.523 290.429v-17.13M100.57 290.429v-17.13M111.633 290.429v-17.13M122.68 290.429v-17.13"></path>
      </g>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M122.682 278.199h-66.33v12.23h66.33v-12.23z"></path>
      <path
        stroke="#DBDADA"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M351.853 295.08h-11.97M192.531 18.04h52.93"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M263.053 25.77h-131.65c-9.262 0-16.77 7.508-16.77 16.77v255.58c0 9.261 7.508 16.77 16.77 16.77h131.65c9.262 0 16.77-7.509 16.77-16.77V42.54c0-9.262-7.508-16.77-16.77-16.77z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M263.745 44.05v9.27H98.555v-9.27c0-10.09 8.19-18.28 18.28-18.28h128.63c10.09 0 18.28 8.19 18.28 18.28zM263.745 287.35v9.27c0 10.09-8.19 18.28-18.28 18.28h-128.63c-10.09 0-18.28-8.19-18.28-18.28v-9.27h165.19z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M263.745 53.32H98.555v234.03h165.19V53.32z"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M237.875 98.66h66.71c4.13 0 7.48-3.34 7.48-7.48v-4.74h-66.71v4.74c0 4.14-3.35 7.48-7.48 7.48z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M297.088 8.49v77.95h-51.74v4.74c0 4.14-3.35 7.48-7.48 7.48-2.07 0-3.93-.83-5.29-2.19a7.485 7.485 0 01-2.2-5.29V8.49c0-4.14-3.35-7.48-7.48-7.48h66.71c4.13 0 7.48 3.34 7.48 7.48z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M215.422 25.77V8.48c0-2.07.84-3.94 2.2-5.29a7.459 7.459 0 015.29-2.19c4.13 0 7.48 3.34 7.48 7.48v17.29h-14.97z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M237.445 16.41h52.59M237.445 23.46h48.91M237.445 61.73h29.96M237.445 68.79h27.86M237.445 30.52h32.34"></path>
      <path
        fill="#F0EEEE"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M119.709 112.309l4.24-10.83h-45.66v-12.79h45.66l-4.24-10.83h9.72l13.81 17.2-13.81 17.26h-9.72v-.01z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M115.061 112.309l4.24-10.83h-45.66v-12.79h45.66l-4.24-10.83h9.72l13.81 17.2-13.81 17.26h-9.72v-.01z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M138.578 95.049h4.65"></path>
      <path
        stroke="#DBDADA"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M67.523 92.55V81.79h15.78M90.813 134.31V111.4M46.71 237.61c4.5-15.97 19.2-27.7 36.59-27.7M394.815 271.84v8.77c0 7.97-6.49 14.47-14.47 14.47h-21.54M90.813 44.05c0-14.33 11.669-26.01 26.019-26.01h27.91M149.367 18.04h11.49"></path>
      <path
        fill="#F0EEEE"
        stroke="#3F6EEC"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M140.867 158.429h12.77v-16.6c0-18.99 13.88-32.72 33.36-32.72 19.48 0 33.36 13.72 33.36 32.72v4.95h-16.92v-4.95c0-9.58-6.86-16.44-16.44-16.44-9.58 0-16.44 6.86-16.44 16.44v16.6h27.93v16.28h-27.93v16.44c0 9.74 6.86 16.6 16.44 16.6 9.58 0 16.44-6.86 16.44-16.6v-4.79h16.92v4.79c0 19.15-13.88 32.88-33.36 32.88-19.48 0-33.36-13.73-33.36-32.88v-16.44h-12.77v-16.28z"></path>
      <path
        fill="#fff"
        stroke="#3F6EEC"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M134.188 158.429h12.77v-16.6c0-18.99 13.88-32.72 33.36-32.72 19.48 0 33.36 13.72 33.36 32.72v4.95h-16.921v-4.95c0-9.58-6.859-16.44-16.439-16.44s-16.44 6.86-16.44 16.44v16.6h27.93v16.28h-27.93v16.44c0 9.74 6.86 16.6 16.44 16.6 9.58 0 16.439-6.86 16.439-16.6v-4.79h16.921v4.79c0 19.15-13.88 32.88-33.36 32.88-19.48 0-33.36-13.73-33.36-32.88v-16.44h-12.77v-16.28z"></path>
      <path
        fill="#DBDADA"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M231.241 248.48h-17.03v17.03h17.03v-17.03zM190.621 248.48h-17.83a8.51 8.51 0 00-8.51 8.51v.01c0 4.7 3.81 8.51 8.51 8.51h17.83c4.7 0 8.51-3.81 8.51-8.51v-.01a8.51 8.51 0 00-8.51-8.51zM149.195 256.99c0 5.01-4.06 9.07-9.07 9.07h-3.91v-.89a9.064 9.064 0 010-16.36v-.89h3.91c5.01 0 9.07 4.06 9.07 9.07z"></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M227.335 248.48h-17.03v17.03h17.03v-17.03zM186.699 248.48h-17.83a8.51 8.51 0 00-8.51 8.51v.01c0 4.7 3.81 8.51 8.51 8.51h17.83c4.7 0 8.51-3.81 8.51-8.51v-.01a8.51 8.51 0 00-8.51-8.51zM136.203 266.06a9.07 9.07 0 100-18.14 9.07 9.07 0 000 18.14z"></path>
      <path
        fill="#F0EEEE"
        stroke="#3F6EEC"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M357.308 164.01v12.64h-16.08v16.079h-12.64V176.65h-16.08v-12.64h16.08v-16.08h12.64v16.08h16.08z"></path>
      <path
        fill="#fff"
        stroke="#3F6EEC"
        strokeMiterlimit="10"
        strokeWidth="1.42"
        d="M351.847 164.01v12.64h-16.08v16.079h-12.64V176.65h-16.08v-12.64h16.08v-16.08h12.64v16.08h16.08z"></path>
    </SvgIcon>
  )
}
